"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionnaireInputToRequestTransformer = void 0;
const QuestionnaireTypes_1 = require("../Enum/QuestionnaireTypes");
class QuestionnaireInputToRequestTransformer {
    constructor(dateFormatter) {
        this.dateFormatter = dateFormatter;
    }
    toHistory(data) {
        var _a, _b, _c, _d;
        const response = {
            car_damage: (_a = data['car_damage']) !== null && _a !== void 0 ? _a : '',
            service_history: (_b = data['service_history']) !== null && _b !== void 0 ? _b : '',
            tyre_condition: (_c = data['tyre_condition']) !== null && _c !== void 0 ? _c : '',
            warning_lights: (_d = data['warning_lights']) !== null && _d !== void 0 ? _d : '',
        };
        return response;
    }
    toDetails(data) {
        var _a, _b;
        const response = {
            mileage: (_a = data['mileage']) !== null && _a !== void 0 ? _a : '',
            vehicle_colour: (_b = data['vehicle_colour']) !== null && _b !== void 0 ? _b : '',
        };
        return response;
    }
    toCondition(data) {
        var _a, _b;
        const response = {
            condition: (_a = data['condition']) !== null && _a !== void 0 ? _a : '',
            reg_expiration: (_b = data['reg_expiration']) !== null && _b !== void 0 ? _b : '',
            finance_owing: Number.parseInt(data['amount_owing'], 10) > 0 ? "Yes" : "No",
        };
        if (!response.reg_expiration) {
            let now = new Date(new Date().setFullYear(new Date().getFullYear() + 1));
            response.reg_expiration = this.dateFormatter.format(now, "yyyy-mm-dd");
        }
        return response;
    }
    toFinance(data) {
        const response = {};
        if (Number.parseInt(data['amount_owing'], 10) > 0) {
            response.amount_owing = data['amount_owing'];
        }
        return response;
    }
    toExtraOptions(data) {
        return {
            [QuestionnaireTypes_1.QuestionnaireTypes.OPTIONAL_EXTRAS]: data[QuestionnaireTypes_1.QuestionnaireTypes.OPTIONAL_EXTRAS]
        };
    }
    toFactoryFitted(data) {
        return {
            [QuestionnaireTypes_1.QuestionnaireTypes.FACTORY_FITTED_OPTIONS]: data[QuestionnaireTypes_1.QuestionnaireTypes.FACTORY_FITTED_OPTIONS],
        };
    }
}
exports.QuestionnaireInputToRequestTransformer = QuestionnaireInputToRequestTransformer;
